export const SDK_NAME = 'sentry.javascript.browser';
export const SDK_VERSION = '4.6.6';
